import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, Subject, of as observableOf } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { StringDecoder } from 'string_decoder';
import { HttpParamsOptions, OfbizLookupField, lookUpRequests } from '../ofbiz-form-model';

@Injectable({
  providedIn: 'root'
})
export class LookupFieldService {
  private lookUpQuerySubject = new Subject<any>();
  lookUpEndPoint: string;
  lookUpEntity: string;
  lookUpSearchFields: string;
  lookUpFormName: string;
  lookUpConditionFields: any[] = [];
  isLookedUp: Boolean = false;

  private lookupSelectedValueSubject = new Subject<any>();

  readonly result = this.lookUpQuerySubject.pipe(
    liveSearch(query => this.doLookUp(query, this.lookUpSearchFields, this.lookUpEntity, this.lookUpFormName, this.lookUpConditionFields))
  )

  constructor(
    @Inject('baseUrl') private baseUrl: string,
    private http: HttpClient) { }

  getBaseUrl() {
    return this.baseUrl;
  }

  doLookUp(query: string, searchFields: string, entityName: string, fieldFormName: string, conditionFields: any[]) {
    // let form = new FormData();
    // form.append("term",query);
    console.log({ TracklookupField: "yeah" });
    const endPoint = "widgets/form/value/" + fieldFormName;

    const url = this.baseUrl + endPoint + "?";
    const queryType = fieldFormName === "LookupLocale" ? "localeName" : "term";
    console.log({ TracklookupQuery: query });
    console.log(typeof query);
    let urlString;
    /* let queryType = "term";
    if(fieldFormName === "LookupLocale"){
      queryType = "localString"
    } */
    if (typeof query === "string" && query.length > 0) {
      if (conditionFields != null && conditionFields.length > 0) {
        const encoded = encodeURIComponent(JSON.stringify(conditionFields));
        urlString = `${url}location=component://kwikstore/widget/KwikstoreForms.xml&${queryType}=${query}&entityName=${entityName}&searchFields=${searchFields}&conditionFields=${encoded}`;
      } else {
        urlString = `${url}location=component://kwikstore/widget/KwikstoreForms.xml&${queryType}=${query}&entityName=${entityName}&searchFields=${searchFields}`;
      }
      return this.http.get<any>(urlString).pipe(
        map((response: any) => {
          const statusCode = response.statusCode;
          switch (statusCode) {
            case 200:
              if (response.successMessage == "OK") {
                const data = response.data;
                const formData = data["formData"];
                const rows: any[] = formData.rows;
                return rows;
              }
              break;
            case 404:

              break;
            case 500:

              break;

            default:
              break;
          }
        }),
        catchError(err => of([]))
      );
    } else {
      return of([]);
    }

  }
  lookUpInitial(query: string, fieldName: string): Observable<any> {
    const empty = "No records Found";
    const lookUpRequest = this.getLookupRequestDetail(fieldName);
    if (lookUpRequest != null) {
      return this.doLookUp(query, lookUpRequest.endPoint, lookUpRequest.entityName, this.lookUpFormName, this.lookUpConditionFields)
        .pipe(
          map(resp => resp)
        );
    } else {
      return observableOf(empty);
    }


  }
  getLookupRequestDetail(fieldName: string) {
    let lookupRequestDetail = null;
    lookupRequestDetail = lookUpRequests.find(lookUpRequest => lookUpRequest.fieldName === fieldName);
    /* if(endpointObject){
      endPoint = endpointObject.endPoint;
    } */
    return lookupRequestDetail;
  }
  /**
   *
   * @param query The term to be used in the search
   * @param fieldName Name of the form field for which the lookup is done
   * @param entityName Name of the Entity to be searched
   * @param searchFields String Fields that will be searched on the backend
   * @param fieldFormName Name of the remote form which will be used to return results
   * @param conditionFields Optional condition fields as key/value maps to be used in the search
   */
  lookUp(query: string, fieldName: string, entityName: string, searchFields: string, fieldFormName: string, conditionFields?: any[]): void {
    console.log({ TrackLookup: { query: query, fieldName: fieldName, entityName: entityName, searchFields: searchFields } })
    if (searchFields != null && entityName != null) {
      console.log({ TrackLookupField: "No endPoint & No entityName", field: fieldName })

      this.lookUpSearch(query, searchFields, entityName, fieldFormName, conditionFields);
    } else {
      console.log({ TrackLookupField: "GetLookupRequestDetail" })
      const lookUpRequest = this.getLookupRequestDetail(fieldName);
      console.log({ TrackLookupField: { lookUpRequest: lookUpRequest } });
      // console.log(query);
      // console.log(endpoint);
      // this.contentIdStart = contentIdStart;
      if (lookUpRequest != null) {
        this.lookUpEndPoint = lookUpRequest.endPoint;
        this.lookUpEntity = lookUpRequest.entityName;
        this.lookUpQuerySubject.next(query);
        this.lookUpQuerySubject.complete();
      }
    }

  }

  lookUpSearch(query: string, searchFields: string, entityName: string, fieldFormName: string, conditionFields: any[]): void {
    console.log({ TrackLookupField: { function: "lookUpSearch", detail: { query: query, searchFields: searchFields, entityName: entityName, conditionFields: conditionFields } } })
    this.lookUpSearchFields = searchFields;
    this.lookUpConditionFields = conditionFields;
    this.lookUpEntity = entityName;
    this.lookUpFormName = fieldFormName;
    this.lookUpQuerySubject.next(query);
  }

  isSelected() {
    this.isLookedUp = !this.isLookedUp;
    console.log({ TrackIsLookedUp: this.isLookedUp });
  }

  resetLookUp(): void {
    console.log("Resetting ....")
    if (!this.isLookedUp) {
      const emptyString: string = "";
      this.lookUpQuerySubject.next(of(emptyString));
    }
  }
  /**
   * Receives the result from a lookup action and populat the lookupSelectedValueSubject
   * @param data
   */
  setLookupSelectedValue(data: any): void {
    this.lookupSelectedValueSubject.next(data);
    console.log({ TrackThisIsLookedUp: this.isLookedUp });
  }
  /**
   * Access to the lookupSelectedValueSubject via subscription
   * @returns
   */
  getLookupSelectedValue(): Observable<any> {
    return this.lookupSelectedValueSubject.asObservable();
  }
  /**
   *
   * @param targetParameterList List of target parameters to be converted to string
   * @returns string with comma separated searchFields
   */
  convertListToString(targetParameterList: []): string {
    let searchFields = "";
    if (targetParameterList.length > 0) {
      searchFields = targetParameterList.join(', ');
    }
    return searchFields;
  }
  /**
   * @comment Function to get an singular raw field data for a lookup field given the field name and form name
   * @comment This function is a usefull when using a lookup field or a textqbe field when you need the individual field without the entire form
   * @param fieldName The name of the field to be returned
   * @param formName The name of the form to be used
   * @param formList The list of forms containing the form which contains the field
   * @returns rawField object
   */
  getLookupRawField(fieldName: string, formName: string, formList: any[]): any {
    console.log({ TrackGetLookupRawField: { fieldName: fieldName, formName: formName } });
    let rawField = null
    if (formList.length > 0) {
      for (const form of formList) {
        if (form.formName === formName) {
          const fields = form.fields;
          for (const field of fields) {
            if (field.name === fieldName) {
              rawField = field;
            }
          }
        }
      }
    }
    console.log({ TrackRawField: rawField });
    return rawField
  }

}

export function liveSearch<T, R>(
  dataCb: (query: T) => Observable<R>,
  delay = 250
) {
  return (source$: Observable<T>) => source$.pipe(
    startWith(''),
    debounceTime(delay),
    distinctUntilChanged(),
    switchMap(dataCb)
  )
}
